import React, { useState, useCallback, useEffect } from 'react';
import { CircleLoader } from '@hpstellar/core';

import { useCartActions } from '../../../hooks/useCartState';
import ToggleInput from './toggle-input';

const isValidZipCode = zipCode => {
    return zipCode != null && zipCode.trim().match(/^(?!00000)\d{5}$/) != null;
};

export default ({ zipCode, defaultErrorMessage = 'Please enter a valid zipcode' }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isExpanded, setExpanded] = useState(false);
    const { setZipCode } = useCartActions();
    useEffect(() => {
        //when the zip code is changed, close the input
        setExpanded(false);
    }, [zipCode]);
    const onSubmit = useCallback(zipCode => {
        if (!isValidZipCode(zipCode)) {
            setErrorMessage(defaultErrorMessage);
            return;
        }
        zipCode = zipCode.trim();
        setIsLoading(true);
        setErrorMessage(null);
        setZipCode(zipCode)
            .then(resp => {
                const { errorMessage } = resp || {};
                if (errorMessage) {
                    setErrorMessage(defaultErrorMessage);
                }
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
                setErrorMessage(defaultErrorMessage);
            });
    }, []);
    const inputProps = {
        placeholder: zipCode || 'Zip Code',
        icon: isLoading ? <CircleLoader className="input-loader" /> : undefined,
        onSubmit,
    };
    return (
        <ToggleInput
            className="zip-code-input"
            inputProps={inputProps}
            errorMessage={errorMessage}
            onToggle={() => setExpanded(!isExpanded)}
            isExpanded={isExpanded}
        >{`${zipCode} - Change`}</ToggleInput>
    );
};
